import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './fonts.css';
import './index.css'
import App from './App.tsx'
import { Helmet, HelmetProvider } from "react-helmet-async";
import { DebugBoundary } from './components/DebugBoundary.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { buildHomePageSeo } from './utils/eventSeo';

const homePageSeo = buildHomePageSeo();

createRoot(document.getElementById('root')!).render(
  <DebugBoundary>
    <ErrorBoundary>
      <StrictMode>
        <HelmetProvider>
          <Helmet>
            <title>{homePageSeo.title}</title>
            <link rel="icon" type="image/png" href="/favicon.png" />
            <meta name="description" content={homePageSeo.metaDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={homePageSeo.ogTitle} />
            <meta property="og:description" content={homePageSeo.ogDescription} />
            <meta property="og:image" content="https://alentours.ca/favicon.png" />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={homePageSeo.title} />
            <meta name="twitter:description" content={homePageSeo.metaDescription} />
            <meta name="twitter:image" content="https://alentours.ca/favicon.png" />
          </Helmet>
          <App />
        </HelmetProvider>
      </StrictMode>
    </ErrorBoundary>
  </DebugBoundary>,
)
